import DashboardRoute from "./dashboard/Dashboard.Route";
import PlansRoute from "./plans/PlansRoute";
import PaymentsRoute from "./payments/PaymentsRoute";
import CustomerRoute from "./customer/CustomerRoute";

const PrivateRoute = () => {
    return [
        ...DashboardRoute(),
        ...PlansRoute(),
        ...PaymentsRoute(),
        ...CustomerRoute(),
    ]
}

export default PrivateRoute
